export default __webpack_public_path__ + "static/img/vogue_scene_animated_0743.b84d672.webp";